/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "BGN" | "CAD" | "CHF" | "CLP" | "CNH" | "CNY" | "CZK" | "DKK" | "EUR" | "GBP" | "HKD" | "HUF" | "ISK" | "JPY" | "MXN" | "NOK" | "NZD" | "PLN" | "ROL" | "RON" | "RUB" | "SEK" | "SGD" | "USD" | "ZAR" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type SalesTaxList_viewer$ref: FragmentReference;
declare export opaque type SalesTaxList_viewer$fragmentType: SalesTaxList_viewer$ref;
export type SalesTaxList_viewer = {|
  +ibSalesTaxes: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +processedAt: ?any,
        +processedBy: ?{|
          +username: string,
          +fullName: ?string,
        |},
        +taxableDescription: string,
        +ignored: boolean,
        +currency: Currency,
        +salesTax: number,
        +reportDate: any,
        +updatedAt: any,
        +notes: ?{|
          +id: string
        |},
        +brokeractivityPtr: {|
          +brokeractivitytransactionSet: {|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +account: {|
                  +name: ?string,
                  +id: string,
                |},
                +brokeractivitytransactioncontractdeltaSet: {|
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +portfolio: {|
                        +id: string
                      |},
                      +contract: {|
                        +id: string,
                        +symbol: string,
                      |},
                      +quantity: number,
                    |}
                  |}>
                |},
                +brokeractivitytransactioncashdeltaSet: {|
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +currency: Currency,
                      +quantity: number,
                    |}
                  |}>
                |},
              |}
            |}>
          |}
        |},
      |}
    |}>,
    +count: ?number,
  |},
  +$refType: SalesTaxList_viewer$ref,
|};
export type SalesTaxList_viewer$data = SalesTaxList_viewer;
export type SalesTaxList_viewer$key = {
  +$data?: SalesTaxList_viewer$data,
  +$fragmentRefs: SalesTaxList_viewer$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v2 = [
  (v0/*: any*/)
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SalesTaxList_viewer",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "first",
      "type": "Int",
      "defaultValue": 10
    },
    {
      "kind": "LocalArgument",
      "name": "offset",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "search",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "reportDate",
      "type": "Date",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "currency",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "processedAt_Isnull",
      "type": "Boolean",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "ignored",
      "type": "Boolean",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "ibSalesTaxes",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "currency",
          "variableName": "currency"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "ignored",
          "variableName": "ignored"
        },
        {
          "kind": "Variable",
          "name": "offset",
          "variableName": "offset"
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "-createdAt"
        },
        {
          "kind": "Variable",
          "name": "processedAt_Isnull",
          "variableName": "processedAt_Isnull"
        },
        {
          "kind": "Variable",
          "name": "reportDate",
          "variableName": "reportDate"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        }
      ],
      "concreteType": "IBSalesTaxNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "IBSalesTaxNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "IBSalesTaxNode",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "processedAt",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "processedBy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserNode",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "username",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "fullName",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "taxableDescription",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "ignored",
                  "args": null,
                  "storageKey": null
                },
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "salesTax",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "reportDate",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "updatedAt",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "notes",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "NotesNode",
                  "plural": false,
                  "selections": (v2/*: any*/)
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "brokeractivityPtr",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "BrokerActivityNode",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "brokeractivitytransactionSet",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "BrokerActivityTransactionNodeConnection",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "BrokerActivityTransactionNodeEdge",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "BrokerActivityTransactionNode",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "account",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "AccountNode",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "ScalarField",
                                      "alias": null,
                                      "name": "name",
                                      "args": null,
                                      "storageKey": null
                                    },
                                    (v0/*: any*/)
                                  ]
                                },
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "brokeractivitytransactioncontractdeltaSet",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "BrokerActivityTransactionContractDeltaNodeConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "edges",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "BrokerActivityTransactionContractDeltaNodeEdge",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "LinkedField",
                                          "alias": null,
                                          "name": "node",
                                          "storageKey": null,
                                          "args": null,
                                          "concreteType": "BrokerActivityTransactionContractDeltaNode",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "kind": "LinkedField",
                                              "alias": null,
                                              "name": "portfolio",
                                              "storageKey": null,
                                              "args": null,
                                              "concreteType": "PortfolioNode",
                                              "plural": false,
                                              "selections": (v2/*: any*/)
                                            },
                                            {
                                              "kind": "LinkedField",
                                              "alias": null,
                                              "name": "contract",
                                              "storageKey": null,
                                              "args": null,
                                              "concreteType": "ContractNode",
                                              "plural": false,
                                              "selections": [
                                                (v0/*: any*/),
                                                {
                                                  "kind": "ScalarField",
                                                  "alias": null,
                                                  "name": "symbol",
                                                  "args": null,
                                                  "storageKey": null
                                                }
                                              ]
                                            },
                                            (v3/*: any*/)
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "brokeractivitytransactioncashdeltaSet",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "BrokerActivityTransactionCashDeltaNodeConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "edges",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "BrokerActivityTransactionCashDeltaNodeEdge",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "LinkedField",
                                          "alias": null,
                                          "name": "node",
                                          "storageKey": null,
                                          "args": null,
                                          "concreteType": "BrokerActivityTransactionCashDeltaNode",
                                          "plural": false,
                                          "selections": [
                                            (v1/*: any*/),
                                            (v3/*: any*/)
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "count",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b31843667140ab478618f2178255602a';
module.exports = node;
